import React, { PureComponent } from 'react'
import Alerts from './Alert'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import { Logo, Loader } from '../../Images'
import "../../css/hover.css"
import "../../css/review.css"
import "../../css/style.css"
import "../../css/responsive.css"
import "../../css/animate.css"

const mapStateToProps = (state) => {
    return {
        common: state.Common
    }
}

const mapDispatchToProps = dispatch => ({

});
const getCurrentTime = () => {

    const now = new Date();

    const hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${hours}.${minutes}`;
}
class Header extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            currentTime: getCurrentTime(),
            showStickyMenu: false
        }
        this.menuStartHeight = 300;

    }

    componentDidMount() {
        const pathname = window.location.pathname
        this.timer = setInterval(() => {
            this.setState({
                currentTime: getCurrentTime()
            });
        }, 1000);
        if (!this.props.home) {
            import("../../css/template.css");

        }
        window.addEventListener("scroll", this.handleScroll);
        if (!pathname.startsWith("/day-tours/") && !pathname.startsWith("/round-tours/") && pathname != "/confirm-reserve") {
            sessionStorage.removeItem("tourState");
        }
        if (!pathname.startsWith("/vehicle-transfers")) {
            sessionStorage.removeItem("vehicleState");
        }
        if (!pathname.startsWith("/transport/") && pathname != "/transport/confirm/reserve") {
            sessionStorage.removeItem("transportState");
        }
        if (!pathname.startsWith("/maldives/") && pathname != "/maldive/resort/confirm-reserve" && pathname != "/maldive/package/confirm-reserve") {
            sessionStorage.removeItem("maldiveState");
        }
        
        if (!pathname.startsWith("/day-tours")) {
            sessionStorage.removeItem("searchState");
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener("scroll", this.handleScroll);
    }
    handleScroll = () => {
        const scrollTop = window.scrollY;

        if (scrollTop > this.menuStartHeight) {
            this.setState({ showStickyMenu: true });
        } else {
            this.setState({ showStickyMenu: false });
        }
    };
    handlePathPush(path){
        sessionStorage.removeItem("searchState");
        console.log()
        setTimeout(() => {
            if(window.location.pathname ==path) {
                window.location.reload()
            } else {
                this.props.history.push(path)
            }
        }, 200);
    }

    render() {
        return (
            <header id="loader-overlay">
                <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
                <div className={"man-mnudiv" + (!this.props.home ? " in-border" : "")}>
                    <div className="container" style={{ paddingBottom: this.props.home ? 15 : null }}>
                        <div className="row">
                            <div className="col-lg-2 col-md-3 col-sm-10">
                                <div className="logo">
                                    <a href="/">
                                        <img src={Logo} width="165" height="26" alt="Logo" />
                                    </a>
                                </div>
                            </div>


                            {!this.props.home && !this.state.showStickyMenu ? <div className="col-lg-8 col-md-6 res-non">
                                <div className="col-lg-12">
                                    <ul className="fix-cat hed top-head row">
                                        <li onClick={()=>this.handlePathPush("/day-tours")}><a className="col-md-2 daytor">Day Tours</a></li>
                                        <li><a className="col-md-2 col-2 maltyday" href="/round-tours">multiday tours</a></li>
                                        <li><a className="col-md-2 thinstodo" href="/things-to-do">things to do</a></li>
                                        <li><a className="col-md-2 transfer" href="/vehicle-transfers">transfers</a></li>
                                        <li><a className="col-md-2 transport" href="/transport">Rent a Car</a></li>
                                        <li><a className="col-md-2 male" href="/maldives">maldives</a></li>
                                    </ul>
                                </div></div> : <div className="col-lg-8 col-md-6"></div>}


                            <div className="col-lg-2 col-md-3 col-sm-5 col-6">
                                <div className="log-tm">
                                    <div className="time">  {this.state.currentTime} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showStickyMenu && (<div className="fix-cat-row saub-rw opn">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <ul className="fix-cat row">
                                    <li className='col-md-2'onClick={()=>this.handlePathPush("/day-tours")}>
                                        <a className="daytor">
                                            Day Tours
                                        </a>
                                    </li>
                                    <li className='col-md-2'>
                                        <a className="maltyday" href="/round-tours">
                                            multiday tours
                                        </a>
                                    </li>
                                    <li className='col-md-2'>
                                        <a className="thinstodo" href="/things-to-do">
                                            things to do
                                        </a>
                                    </li>
                                    <li className='col-md-2'>
                                        <a className="transfer" href="/vehicle-transfers">
                                            transfer
                                        </a>
                                    </li>
                                    <li className='col-md-2'>
                                        <a className="transfer" href="/transport">
                                            Rent a Car
                                        </a>
                                    </li>
                                    <li className='col-md-2'>
                                        <a className="male" href="/maldives">
                                            maldives
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                )}
                <div className="nav-frm" id="loadHeadSearch">
                    <form>
                        <div className="loca">
                            <input
                                type="text"
                                className="browses"
                                placeholder="Pick up Location"
                            />
                            <div className="browses-list">
                                <span>Colombo</span>
                                <span>Kandy</span>
                                <span>Sigiriya</span>
                            </div>
                        </div>

                        <div className="key">
                            <input
                                type="text"
                                className="remove-data get-input-length inphov"
                                placeholder='Search for Keyword. “Sigiriya” or “Kandy” etc.'
                            />

                            <div className="serh-list full" id="sil-form">
                                <div className="col-cus-4">
                                    <div className="search-list-itme">
                                        <div className="search-header-new">DAY TOURS</div>
                                        <ul>
                                            <li>
                                                <a href="/day-tours/sample-tour/0/" target="_blank" rel="noreferrer">
                                                    Sample Day Tour
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/day-tours/colombo/0/" target="_blank" rel="noreferrer">
                                                    Colombo Day Tour
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-cus-4">
                                    <div className="search-list-itme">
                                        <div className="search-header-new">ROUND TOURS</div>
                                        <ul>
                                            <li>
                                                <a href="/round-tours/cultural/sample" target="_blank" rel="noreferrer">
                                                    Cultural Tour
                                                </a>
                                            </li>
                                            <li>
                                                <a href="/round-tours/adventure/sample" target="_blank" rel="noreferrer">
                                                    Adventure Tour
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="col-cus-4">
                                    <div className="search-list-itme">
                                        <div className="search-header-new">THINGS TO DO</div>
                                        <ul>
                                            <li>
                                                <a href="/things-to-do/whale-watching">Whale Watching</a>
                                            </li>
                                            <li>
                                                <a href="/things-to-do/hiking">Hiking</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <span className="clear"></span>
                            </div>
                        </div>

                        <a className="submit" href="/allSearchResult/?id=searchKey">

                        </a>
                        <div className="clear"></div>
                    </form>
                </div>

                {this.props.common.pageLoading ?
                    <div id="loader">
                        <img src={Loader} />
                    </div> : null}
            </header>
        );
    }
}

Header.defaultProps = {
    home: false,
}


export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(Header);